import axiosInstance from '../Core/RestHelper';
import { DeploymentConfig, Status } from '../Model/Deployment';
import { Site } from '../Model/Site';

type ServiceResponse<T> = {
  success: boolean;
  data?: T;
  error?: string;
};

export class DeploymentService {
  static async CreateDeployment(deployment: DeploymentConfig): Promise<ServiceResponse<string>> {
    try {
      const { resources, ...details } = deployment; // Exclude 'resources'
      const response = await axiosInstance.post('/deploy/deployments', details);
      const { id } = response.data;
      return { success: true, data: id };
    } catch (error: any) {
      const message = error?.response?.data?.detail;
      console.error("Deployment creation failed:", message);
      return { success: false, error: message };
    }
  }

  static async TriggerDeployment(id: string): Promise<ServiceResponse<Status>> {
    try {
      const response = await axiosInstance.get(`/deploy/trigger-deployment/${id}`);
      return { success: true, data: response.data };
    } catch (error: any) {
      const message = error?.response?.data?.detail;
      console.error("Deployment trigger failed:", message);
      return { success: false, error: message };
    }
  }

  static async GetDeployment(id: string): Promise<ServiceResponse<Site>> {
    try {
      const response = await axiosInstance.get(`/deploy/deployments/${id}`);
      return { success: true, data: response.data };
    } catch (error: any) {
      const message = error?.response?.data?.detail;
      console.error("Deployment details failed:", message);
      return { success: false, error: message };
    }
  }

  static async GetDeploymentLogs(id: string): Promise<string[]> {
    try {
      const response = await axiosInstance.post(`/deploy/deployments/${id}/logs`);
      return response.data;
    } catch (error: any) {
      console.error("Deployment logs details failed:", error?.response?.data?.detail);
      return [];
    }
  }

  static async GetHostedLink(id:string):Promise<ServiceResponse<string>>{
    try{
      const respose = await axiosInstance.get(`/deploy/show-hosted-link/${id}`);
      return respose.data
    }catch (error: any) {
      console.error("Deployment logs details failed:", error?.response?.data?.detail);
      return error;
    }
  }
}
